import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { Agreement } from '@models/agreement.model';
import { UploadDocumentResponse } from '@models/upload-document-response';

export const AgreementActions = createActionGroup({
  source: 'Agreement',
  events: {
    'Load Agreements': emptyProps(),
    
    'Refresh Button Pressed': emptyProps(),
    'Search Year Changed': props<{ year: number }>(),
    'Get Agreements Success': props<{ agreements: Agreement[] }>(),
    'Get Agreements Failure': props<{ error: string }>(),

    'Open In Docusign Pressed': props<{ envelopeId: string }>(),

    'Select Document File': props<{ file: File }>(),
    'Clear Selected Document File': emptyProps(),
    
    'Upload Document': props<{ file: File, documentTypeId: number }>(),
    'Document Upload Progress': props<{ progress: number }>(),
    'Document Upload Success': props<{ response: UploadDocumentResponse }>(),
    'Document Upload Failure': props<{ error: string }>(),
    
    'Load Documents': emptyProps(),
    'Load Documents Success': props<{ documents: UploadDocumentResponse[] }>(),
    'Load Documents Failure': props<{ error: string }>(),
    
    'Download Document': props<{ documentId: number }>(),
    'Download Document Success': emptyProps(),
    'Download Document Failure': props<{ error: string }>(),

    'Download Org Agreement': props<{ envelopeId: string }>(),
    'Download Org Agreement Success': emptyProps(),
    'Download Org Agreement Failure': props<{ error: string }>(),

    'Send Org Agreement With Email': props<{ email: string; name: string }>(),
    'Send Org Agreement With Email Success': emptyProps(),
    'Send Org Agreement With Email Failure': props<{ error: string }>(),

    'Void Org Agreement': props<{ envelopeId: string }>(),
    'Void Org Agreement Success': emptyProps(),
    'Void Org Agreement Failure': props<{ error: string }>(),

    'Clear Document Upload State': emptyProps()
  }
});
